import React from 'react';

//create a class representing the full tracker

class FullTracker extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clickCount: 0,
            //viewCount: 0
        }

        this.increment = this.increment.bind(this);
        this.decrement = this.decrement.bind(this);
        this.reset = this.reset.bind(this);

    }
    
    increment() {
        this.setState( state => ({
            clickCount: state.clickCount + 1
        }));

    }

    decrement() {
        this.setState( state => ({
            clickCount: state.clickCount - 1
        }));
    }

    reset() {
        this.setState({
            clickCount: 0
        });
    }



    render() {
        return (
            <div>
                <div><h1>Welcome to the Click Game</h1></div>
                <button onClick={this.increment}>+1</button>
                <button onClick={this.decrement}>-1</button>
                <button onClick={this.reset}>RESET</button>
                <div><h2>You're Click Score = {this.state.clickCount}</h2></div>
            </div>
        )
    }
}

export default FullTracker;

